var _defs, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgGithub = function SvgGithub(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 514.41 501.71",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: #fff;\n      }\n\n      .cls-1 {\n        fill-rule: evenodd;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M265.49,25.14c-142,0-257.21,115.15-257.21,257.2C8.28,396,82,492.39,184.17,526.41c12.86,2.37,17.58-5.59,17.58-12.38,0-6.13-.24-26.39-.35-47.89-71.56,15.56-86.65-30.34-86.65-30.34-11.7-29.73-28.56-37.64-28.56-37.64C62.85,382.2,88,382.53,88,382.53c25.82,1.81,39.42,26.51,39.42,26.51,22.94,39.31,60.17,27.95,74.85,21.37,2.31-16.62,9-28,16.33-34.39-57.13-6.5-117.19-28.56-117.19-127.11,0-28.08,10-51,26.51-69-2.67-6.48-11.48-32.64,2.49-68.07,0,0,21.6-6.91,70.75,26.37a243.82,243.82,0,0,1,128.81,0c49.09-33.28,70.66-26.37,70.66-26.37,14,35.43,5.2,61.59,2.53,68.07,16.49,18,26.47,41,26.47,69,0,98.79-60.17,120.54-117.45,126.91,9.23,8,17.44,23.63,17.44,47.63,0,34.41-.29,62.11-.29,70.58,0,6.85,4.63,14.87,17.66,12.34,102.15-34.05,175.75-130.42,175.75-244C522.69,140.29,407.53,25.14,265.49,25.14Z",
    transform: "translate(-8.28 -25.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M105.7,394.43c-.57,1.28-2.58,1.66-4.41.78s-2.91-2.58-2.31-3.86,2.57-1.68,4.43-.8,2.93,2.6,2.29,3.88Zm-3.17-2.35",
    transform: "translate(-8.28 -25.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M116.12,406.05c-1.23,1.13-3.63.61-5.26-1.19s-2-4.19-.75-5.35,3.59-.6,5.28,1.19,2,4.2.73,5.35Zm-2.46-2.63",
    transform: "translate(-8.28 -25.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M126.26,420.86c-1.58,1.1-4.16.07-5.75-2.22s-1.58-5,0-6.13,4.13-.11,5.75,2.16,1.57,5.07,0,6.19Zm0,0",
    transform: "translate(-8.28 -25.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M140.15,435.17c-1.41,1.56-4.41,1.14-6.61-1s-2.87-5-1.46-6.57,4.45-1.12,6.66,1,2.91,5,1.41,6.57Zm0,0",
    transform: "translate(-8.28 -25.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M159.32,443.48c-.63,2-3.52,2.93-6.43,2.07s-4.81-3.24-4.22-5.27,3.51-3,6.44-2.07,4.81,3.22,4.21,5.27Zm0,0",
    transform: "translate(-8.28 -25.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M180.37,445c.07,2.12-2.4,3.88-5.46,3.92s-5.56-1.65-5.6-3.73,2.42-3.89,5.49-3.94,5.57,1.65,5.57,3.75Zm0,0",
    transform: "translate(-8.28 -25.14)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M200,441.69c.36,2.07-1.76,4.19-4.8,4.76s-5.75-.73-6.13-2.78,1.79-4.25,4.77-4.8,5.77.72,6.16,2.82Zm0,0",
    transform: "translate(-8.28 -25.14)"
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGithub, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Github.08225912.svg";
export { ForwardRef as ReactComponent };